import { createSelector } from '@ngrx/store';

import { betslipSelector } from '../../base/store/selectors';

export const lineSwitcherStateSelector = createSelector(betslipSelector, (state) => state.lineSwitcher);
export const lineSwitcherSwapPickStateSelector = createSelector(lineSwitcherStateSelector, (lineSwitcherState) => lineSwitcherState.swapPickState);
